import {ServiceFieldSettings} from "./ServiceFieldSettings";

/**
 * ServiceFieldParameters описывает параметры настроек полей
 * дополнительных услуг. В параметрах содержатся дефолтные настройки
 * полей, а так же общие для всех вариантов отображений настройки.
 */
export class ServiceFieldParameters {
  /**
   * DefaultSettings содержит настройки по умолчанию для полей дополнительных услуг
   */
  public DefaultSettings: ServiceFieldSettings = ServiceFieldSettings.RestoreSettings({});

  /**
   * IsFieldValueShouldCalculate содержит флаг, отвечающий за функционал
   * автоматического расчета значения для поля. Если флаг включен, то
   * значение поля будет рассчитываться автоматически по формуле из
   * FieldCalculationFormula. Исключение - поле само является источником
   * изменений значений полей.
   */
  public IsFieldValueShouldCalculate: boolean = false;

  /**
   * FieldCalculationFormula содержит формулу для расчета значений поля.
   * Формула должна возвращать значение типа number. В случае, если значение
   * не удалось вычислить или оно не соответствует типу поля, то оно будет
   * проигнорировано, а значение поля сброшено.
   */
  public FieldCalculationFormula: string = "";

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): ServiceFieldParameters {
    let result = new ServiceFieldParameters();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof ServiceFieldParameters) => {
      // @ts-ignore
      result[key] = ServiceFieldParameters.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof ServiceFieldParameters>(field: T, data: any): any {
    let defaults = new ServiceFieldParameters()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "IsFieldValueShouldCalculate":
        return !!data
      case "FieldCalculationFormula":
        return typeof data === "string" ? data : ""
      case "DefaultSettings":
        return ServiceFieldSettings.RestoreSettings(data)
    }

    return defaults[field];
  }
}